"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBCInternationaleSpeditionGmbH = void 0;
exports.IBCInternationaleSpeditionGmbH = {
    id: 'ibcInternationaleSpeditionGmbH',
    companyName: 'IBC Internationale Spedition GmbH',
    transportModes: ['sea'],
    freightGate: {
        isOnboarded: true,
        realm: 'ibcInternationaleSpeditionGmbH',
    },
    isInternal: false,
    isActive: true,
    countries: ['AT'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSUJDSW50ZXJuYXRpb25hbGVTcGVkaXRpb25HbWJILmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2FnZW50cy9kYXRhL0lCQ0ludGVybmF0aW9uYWxlU3BlZGl0aW9uR21iSC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDhCQUE4QixHQUFVO0lBQ2pELEVBQUUsRUFBRSxnQ0FBZ0M7SUFDcEMsV0FBVyxFQUFFLG1DQUFtQztJQUNoRCxjQUFjLEVBQUUsQ0FBQyxLQUFLLENBQUM7SUFDdkIsV0FBVyxFQUFFO1FBQ1QsV0FBVyxFQUFFLElBQUk7UUFDakIsS0FBSyxFQUFFLGdDQUFnQztLQUMxQztJQUNELFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsU0FBUyxFQUFFLENBQUMsSUFBSSxDQUFDO0NBQ3BCLENBQUEifQ==